import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { HeroImageTextStory } from "../shared/hero-image";
import StoryCard from "../shared/story-card";
import Breadcrumb from "../shared/breadcrumbs";
import styles from "./styles.m.css";
import { Link, WithLazy } from "@quintype/components";
import { VikatanResponsiveContainer, PGAdwithAd } from "../../../../rows/ad-free";
import StoryMidPromotion from "../../storyMidContent";
import { isPremium } from "../../../../../data/story";
import { humanizeDate } from "../../../../utils/time-format";
import SocialShareSection from "../../../../atoms/social-share-section";
import assetify from "@quintype/framework/assetify";
import googlenews from "../../../../../../assets/images/Vikatan_google_news_new.svg";
import Media from "react-media";
import CustomAdslot from "../../../../atoms/dfp-ad-custom";
import AudioPlayer from "../../story-audioplayer";
function TextStory(props) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const renderTextStoryHeaderCard = get(props, ["renderTextStoryHeaderCard"], () => null);
  const referenceUrl = get(props, ["story", "metadata", "reference-url"], null);
  const section = get(props, ["story", "sections", "0"], null);
  const storyHeadline = get(props, ["story", "subheadline"], () => null);
  const singleCard = get(props, ["story", "cards"], null);
  const storyId = get(props, ["story", "id"], null);
  const storyIndex = get(props, ["index"], 0);
  const glance = get(props, ["glance"]);
  const readMore = false;
  const story = get(props, ["story"], () => null);
  const evAccess = get(props, ["evAccess"]);
  const cards = readMore ? (isPremium(story) ? [] : singleCard.slice(0, 1)) : singleCard;
  const [userType, setUserType] = useState("F");
  const cardLength = cards.length;

  const [headerSlot, setheaderSlot] = React.useState(false);
  const [ImageSlot, setImageSlot] = React.useState(false);
  const [MidcontentSlot, setMidcontentSlot] = React.useState(false);

  useEffect(() => {
    let search = window && window.location && window.location.search;
    let Utm = new URLSearchParams(search);
    let utmsource = Utm.get("utm_medium");

    if (utmsource === "r") {
      setheaderSlot("22029514685/Realme/Vikatan_mrec_top");
      setImageSlot("22029514685/Realme/Vikatan_small_banner_top");
      setMidcontentSlot("22029514685/Realme/Vikatan_mrec_bottom");
    } else if (utmsource === "x") {
      setheaderSlot("22029514685/xiaomi_lp/Vikatan_mrec_top");
      setImageSlot("22029514685/xiaomi_lp/Vikatan_small_banner_top");
      setMidcontentSlot("22029514685/xiaomi_lp/Vikatan_mrec_bottom");
    } else if (utmsource === "s") {
      setheaderSlot("22029514685/samsung/Vikatan_mrec_top");
      setImageSlot("22029514685/samsung/Vikatan_small_banner_top");
      setMidcontentSlot("22029514685/samsung/Vikatan_mrec_bottom");
    }
  }, []);

  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);

  const adShow = isPremium(story) ? !readMore : true;

  const heroimageWithShare = (
    <React.Fragment>
      <HeroImageTextStory story={props.story} subSection={section} config={props.config} />
      {!readMore && renderSocialMedia()}
    </React.Fragment>
  );

  return (
    <div className="page-content">
      <div className={`container`}>{!glance && <Breadcrumb subSection={section} config={props.config} />}</div>
      <div className={`container ${styles["story-grid"]}`}>
        <div className={styles["main-content"]}>
          <article className={`${styles["story-body"]} js-story`}>
            {glance &&
              headerSlot && (
                <div className={`${styles["header-ad-slot"]}`}>
                  <WithLazy>
                    {() => (
                      <CustomAdslot
                        path={headerSlot && headerSlot}
                        size={[[300, 250], [336, 280]]}
                        id={`div-gpt-ad-2-${storyId}`}
                      />
                    )}
                  </WithLazy>
                </div>
              )}
            <div>
              <div className="desktop hidden-mobile">
                {renderHeaderCard()}
                {heroimageWithShare}
                <p className={`subheadline-main ${styles["subheadline"]}`}>{storyHeadline}</p>
              </div>
              <div className="hidden-mobile">
                <AudioPlayer story={story} />
              </div>
              <div className="mobile hidden-desktop">
                <div className={styles["published-time-wrap"]}>
                  {story["first-published-at"] && (
                    <span className={styles["published"]}>
                      Published:
                      <time className={styles.time} dateTime={new Date(story["first-published-at"]).toISOString()}>
                        {humanizeDate(story["first-published-at"], "relative")}
                      </time>
                    </span>
                  )}
                  {story["last-published-at"] && (
                    <span className={styles["updated"]}>
                      Updated:
                      <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                        {humanizeDate(story["last-published-at"], "relative")}
                      </time>
                    </span>
                  )}
                </div>
                {renderTextStoryHeaderCard()}
                {story.authors && story.authors.length ? (
                  <div className={styles.contributors}>
                    <div className={styles.contributorOuter}>
                      <SocialShareSection story={story} config={props.config} />
                    </div>
                    <div className="goog-vikatan-news">
                      {glance && (
                        <img
                          src="https://gumlet.assettype.com/vikatan/2022-10/74579da7-c4c2-4e26-9553-c81367f137fe/logo_glance.png"
                          alt=""
                          className={styles["google-follow"]}
                          width="118px"
                          height="44px"
                        />
                      )}
                      {!glance && (
                        <a
                          href="https://news.google.com/publications/CAAqBwgKMJ6N_wow3fz3Ag?hl=ta&amp;gl=IN&amp;ceid=IN%3Ata"
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.link}
                        >
                          <img
                            src={assetify(googlenews)}
                            alt=""
                            className={styles["google-follow"]}
                            width="120px"
                            height="26px"
                          />
                        </a>
                      )}
                    </div>
                  </div>
                ) : null}
                <p className={`subheadline-main ${styles["subheadline"]}`}>{storyHeadline}</p>

                {!glance && (
                  <div className="vikatan-top-ad-width ad">
                    <div className="ad-container vikatan-top-ad">
                      <Media query="(max-width:768px)">
                        {matches =>
                          matches ? (
                            <div
                              className={`mobile ${
                                userType === "P" || userType === "T" || userType === "R" ? "" : "ad_300_250"
                              }`}
                            >
                              <PGAdwithAd unit="Vikatan_mobile_article_mid" class="ad_300_250" />
                            </div>
                          ) : null
                        }
                      </Media>
                    </div>
                  </div>
                )}
                {heroimageWithShare}
                <div className="hidden-desktop">
                  <div className={styles["mobile-audioplayer"]}>
                    <AudioPlayer story={story} />
                  </div>
                </div>
                {glance &&
                  ImageSlot && (
                    <div className={styles["hero-image-slot"]}>
                      <WithLazy>
                        {() => (
                          <CustomAdslot
                            path={ImageSlot && ImageSlot}
                            size={[[320, 100], [300, 100], [300, 50]]}
                            id={`div-gpt-ad-3-${storyId}`}
                          />
                        )}
                      </WithLazy>
                    </div>
                  )}
              </div>
              <div className={!glance && evAccess !== "ALLOW_ACCESS" ? styles["story-card-wrapper"] : " "}>
                {cards &&
                  cards.map((card, index) => {
                    return (
                      <React.Fragment key={card.id}>
                        {!glance && (
                          <VikatanResponsiveContainer
                            placement={"text-story"}
                            adtype={parseInt(index + 1)}
                            story={props.story}
                            className="ad_300_250"
                          />
                        )}
                        {!glance && index === 1 ? <StoryMidPromotion story={props.story} /> : null}
                        <StoryCard
                          card={card}
                          story={props.story}
                          showCard={readMore}
                          index={index}
                          storyIndex={storyIndex}
                          cardLength={cardLength}
                          glance={glance}
                        />
                        {glance &&
                          index === 0 &&
                          MidcontentSlot && (
                            <div className={`${styles["mid-ad-slot"]}`}>
                              <WithLazy>
                                {() => (
                                  <CustomAdslot
                                    path={MidcontentSlot && MidcontentSlot}
                                    size={[[336, 280], [300, 250], [300, 300], [320, 100]]}
                                    id={`div-gpt-ad-4-${storyId}`}
                                  />
                                )}
                              </WithLazy>
                            </div>
                          )}
                      </React.Fragment>
                    );
                  })}
              </div>
            </div>

            {!glance && <div id="we-story-end" />}
            {referenceUrl && (
              <div className={styles["external-link-wrapper"]}>
                <Link href={referenceUrl} className={styles["external-link"]} externalLink={referenceUrl}>
                  View Story
                </Link>
              </div>
            )}
            {renderFooter(readMore)}
          </article>
        </div>
        {renderSidebar(adShow)}
      </div>
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any,
  metadata: PropTypes.shape({
    "reference-url": PropTypes.string
  })
});
TextStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  isAccessible: PropTypes.bool,
  relatedStories: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      story: story
    })
  ),
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func,
  handleExpandStory: PropTypes.func,
  renderTextStoryHeaderCard: PropTypes.func
};

export { TextStory };
